import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export function PercentPie({
  columnCount,
  recordsCount
}) {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    setPercent(Math.round(100 * (columnCount / recordsCount)));
  }, [columnCount, recordsCount]);

  return (
    <div
      className="pie"
      style={{ backgroundImage: `conic-gradient(white ${100 - percent}%, #bbb ${100 - percent}%)` }}
      title={`${percent}%`}
    />
  );
}

PercentPie.propTypes = {
  columnCount: PropTypes.number.isRequired,
  recordsCount: PropTypes.number.isRequired
};
